






































































































































































































import {Component, Inject, Vue} from 'vue-property-decorator';
import {
    createUser, deleteUser,
    getAssociatedAreas,
    getAssociatedAutoGroups,
    getAssociatedDealerships,
    getAssociatedPermissions,
    getAvailablePermissions,
    getUserList, searchByArea, searchByAutoGroup, searchByDealership,
    searchByUser, updateUser
} from "../../endpoints";
import dateFormat from "date-fns/format";
import Search from "../utility/Search.vue";
import {Permission, Permissions} from "../../types";
import {serializeForm} from "../../util";

Vue.component("v-search", Search);

@Component
export default class Users extends Vue {

    @Inject("hasPermission")
    hasPermission: Function;

    Permission = Permissions;
    DateFormat = dateFormat;
    SearchByUser = searchByUser;
    SearchByDealership = searchByDealership;
    SearchByArea = searchByArea;
    SearchByAutoGroup = searchByAutoGroup;

    users = [];
    availablePermissions: Permission[] = [];

    currentUserBeingEdited = null;
    currentUserBeingDeleted = null;

    loadingUser: boolean = false;
    loadingUsers: boolean = false;

    submitted: boolean = false;

    addUserForm: {
        email: string;
        first_name: string;
        last_name: string;
        scopes: any[];
        dealerships: any[];
        autoGroups: any[];
        areas: any[];
        password: string;
    } = {
        email: "",
        first_name: "",
        last_name: "",
        password: "",
        scopes: [],
        dealerships: [],
        autoGroups: [],
        areas: []
    };

    async mounted() {

        this.refreshUserList();

        // If the user is not permission to view the available permissions, simply assign an empty array.
        try {
            this.availablePermissions = await getAvailablePermissions();
        } catch (e) {
            this.availablePermissions = [];
        }
    }

    async refreshUserList(id?: number) {

        const params = new URLSearchParams();

        if(id) {
            params.append("id", `${id}`);
        }

        this.loadingUsers = true;

        this.users = await getUserList(params.toString());

        this.loadingUsers = false;
    }

    async onEditUserButtonClick(user) {

        this.currentUserBeingEdited = user.id;

        this.addUserForm.email = user.email;
        this.addUserForm.first_name = user.first_name;
        this.addUserForm.last_name = user.last_name;

        (this.$refs['add-user-modal'] as any).show();

        this.loadingUser = true;

        await Promise.all([
            getAssociatedPermissions(user.id).then(permissions => {
                this.addUserForm.scopes = permissions;
            }).catch(e => {
                // If the user is not permitted to update permissions, simply assign an emtpy array.
                this.addUserForm.scopes = [];
            }),
            getAssociatedDealerships(user.id).then(dealerships => {
                this.addUserForm.dealerships = dealerships;
            }),
            getAssociatedAutoGroups(user.id).then(autoGroups => {
                this.addUserForm.autoGroups = autoGroups;
            }),
            getAssociatedAreas(user.id).then(areas => {
                this.addUserForm.areas = areas;
            })
        ]);

        this.loadingUser = false;
    }

    onUserItemSelected(result) {
        this.refreshUserList(result ? result.id : null);
    }

    async onSubmitUserFormButtonClick() {

        const payload = JSON.stringify({
            basic: serializeForm(this.$refs["add-user-form"] as HTMLFormElement),
            permissions: this.addUserForm.scopes.map(permission => {
                return permission.id;
            }),
            areas: this.addUserForm.areas.map(area => {
                return area.id;
            }),
            dealerships: this.addUserForm.dealerships.map(dealership => {
                return dealership.id;
            }),
            auto_groups: this.addUserForm.autoGroups.map(autoGroup => {
                return autoGroup.id;
            })
        });

        this.submitted = true;

        try {
            if(this.currentUserBeingEdited) {
                await updateUser(payload, this.currentUserBeingEdited);
            } else {
                await createUser(payload);
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.submitted = false;
        }

        this.refreshUserList();

        (this.$refs["add-user-modal"] as any).hide();
    }

    onAddUserModalHidden() {

        this.currentUserBeingEdited = null;

        this.addUserForm.email = "";
        this.addUserForm.first_name = "";
        this.addUserForm.last_name = "";
        this.addUserForm.password = "";
        this.addUserForm.scopes = [];
        this.addUserForm.autoGroups = [];
        this.addUserForm.dealerships = [];
        this.addUserForm.areas = [];
    }

    hasPermissionAssigned(id: number) {
        return this.addUserForm.scopes.filter(permission => {
            return permission.id === id;
        }).length > 0;
    }

    onPermissionAssignedChange(id: number) {

        if(this.hasPermissionAssigned(id)) {
            this.addUserForm.scopes = this.addUserForm.scopes.filter(permission => {
                return permission.id !== id;
            });
        } else {
            this.addUserForm.scopes.push({ id });
        }

    }

    onDealershipResultSelected(result) {
        if(result && !this.addUserForm.dealerships.filter(dealership => { return dealership.id === result.id }).length) {

            const { id, name } = result;

            this.addUserForm.dealerships.push({ id, name });
        }
    }

    onSearchAreaFilterInput(result) {
        if(result && !this.addUserForm.areas.filter(area => { return area.id === result.id }).length) {

            const { id, name } = result;

            this.addUserForm.areas.push({ id, name });
        }
    }

    onSearchAutoGroupInput(result) {
        if(result && !this.addUserForm.autoGroups.filter(autoGroup => { return autoGroup.id === result.id }).length) {

            const { id, name } = result;

            this.addUserForm.autoGroups.push({ id, name });
        }
    }

    deleteDealership(id) {
        this.addUserForm.dealerships = this.addUserForm.dealerships.filter(dealership => {
            return dealership.id !== id
        })
    }

    deleteAutoGroup(id) {
        this.addUserForm.autoGroups = this.addUserForm.autoGroups.filter(autoGroup => {
            return autoGroup.id !== id
        })
    }

    deleteArea(id) {
        this.addUserForm.areas = this.addUserForm.areas.filter(area => {
            return area.id !== id
        })
    }

    async promptUserDeletionClick(id: number) {
        this.currentUserBeingDeleted = id;

        (this.$refs['confirm-user-del'] as any).show()
    }

    async onConfirmUserDeletionButtonClick() {
        await deleteUser(this.currentUserBeingDeleted);

        this.refreshUserList();

        (this.$refs["confirm-user-del"] as any).hide();
    }

    get isAddUserEmailValid() {
        return this.addUserForm.email.length > 0;
    }

    get isAddUserFirstNameValid() {
        return this.addUserForm.first_name.length > 0;
    }

    get isAddUserLastNameValid() {
        return this.addUserForm.last_name.length > 0;
    }

    get isAddUserPasswordValid() {
        return this.currentUserBeingEdited ? true : this.addUserForm.password.length > 0;
    }
}
